import { HTMLAttributes, TdHTMLAttributes, ThHTMLAttributes } from 'react';
import clsx from 'clsx';

export const Table = ({ className, ...props }: HTMLAttributes<HTMLTableElement>) => (
  <div className="w-full overflow-x-auto">
    <table className={clsx('w-full border-collapse text-left text-sm', className)} {...props} />
  </div>
);

export const THead = (props: HTMLAttributes<HTMLTableSectionElement>) => (
  <thead
    className="border-b border-gray-200 text-xs uppercase tracking-wide text-gray-500 dark:border-gray-800 dark:text-gray-400"
    {...props}
  />
);

export const TBody = (props: HTMLAttributes<HTMLTableSectionElement>) => (
  <tbody className="divide-y divide-gray-100 dark:divide-gray-800" {...props} />
);

export const TR = ({ className, ...props }: HTMLAttributes<HTMLTableRowElement>) => (
  <tr className={clsx('hover:bg-gray-50 dark:hover:bg-gray-800/50', className)} {...props} />
);

export const TH = ({ className, ...props }: ThHTMLAttributes<HTMLTableCellElement>) => (
  <th className={clsx('whitespace-nowrap px-4 py-3 font-semibold', className)} {...props} />
);

export const TD = ({ className, ...props }: TdHTMLAttributes<HTMLTableCellElement>) => (
  <td className={clsx('px-4 py-3 text-gray-700 dark:text-gray-300', className)} {...props} />
);
